/*
 * @Description: element-plus upload 组件封装 c-upload
 * @Author: yaoxiaoxiao
 * @Date: 2021-03-17 10:50:34
 * @LastEditors: wangzhenyu
 * @LastEditTime: 2021-07-21 15:22:50
 */
import CUpload from './index.vue'
export default CUpload
